export const AppPermissions = {
    "View Private Reports": 1,
    "View Reports": 2,
    "View Report Media": 3,
    "Update Report": 4,
    "Delete Report": 5,
    "Esclate Report": 6,
    "Add Report Remarks": 7,
    "Share Report": 8,
    "Download Report as Pdf": 9,
    "Manage Contacts": 10,
    "Report Maintenace Issue": 11,
    "Update Maintenace Issue Status": 12,
    "Manage Roles": 13,
    "Manage Users": 14,
    "Reporting Level": 15,
    "Make Announcement": 16,
};
//# sourceMappingURL=appPermissions.js.map